exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--Icon__2fshO{height:16px;width:16px;fill:#99b1c6;display:inline-block}\n", ""]);

// exports
exports.locals = {
	"Icon": "styles--Icon__2fshO",
	"icon": "styles--Icon__2fshO"
};